import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useAuth } from '../../context/AuthContext';
import { useBatchExportWebSocket } from '../../context/BatchExportWebSocketContext';
import LogoutButton from '../LogoutButton';
import Icon from '@mdi/react';
import { mdiLoading } from '@mdi/js';

import './AppHeader.scss';

interface AppHeaderProps {
  currentView?: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({ currentView = 'account-requests' }) => {
    const { accessToken } = useAuth();
    const { processingBatchCount } = useBatchExportWebSocket();
    const navigate = useNavigate();

    const handleNavClick = (view: string) => {
      if (view === 'account-requests') {
        navigate('/account-requests');
      } else if (view === 'batch-exports') {
        navigate('/batch-exports');
      }
    };

  return (
    <div className='app-header'>
      <div className='header-left'>
        <img className='logo' src="https://images.squarespace-cdn.com/content/v1/5e0f65245425f3307a8ba190/1610141473546-Y7JTPTT2J9EOVSSTUQ1U/static1.squarespace-2.png?format=1500w" />
        <nav className='nav-menu'>
          <button 
            className={`nav-item ${currentView === 'account-requests' ? 'active' : ''}`}
            onClick={() => handleNavClick('account-requests')}
          >
            Account Requests
          </button>
          <button 
            className={`nav-item ${currentView === 'batch-exports' ? 'active' : ''}`}
            onClick={() => handleNavClick('batch-exports')}
          >
            Batch Exports
            {processingBatchCount > 0 && (
              <span className="processing-indicator">
                <Icon path={mdiLoading} size={0.75} spin />
              </span>
            )}
          </button>
        </nav>
      </div>
      <LogoutButton />
    </div>
  );
};

export default AppHeader;